module.exports = __webpack_public_path__ + "static/media/mountain_temple.559bfb53.png";